import { formatMonthlyWarriorSocialProof } from '@/lib/impact-counters';
import { useMonthlyWarriorCount } from '@/lib/use-monthly-warrior-count';

interface MonthlyWarriorSocialProofProps {
  className?: string;
  variant?: 'light' | 'dark';
}

export function MonthlyWarriorSocialProof({
  className = '',
  variant = 'light',
}: Readonly<MonthlyWarriorSocialProofProps>): JSX.Element {
  const { count, loading } = useMonthlyWarriorCount();
  const textClass =
    variant === 'dark' ? 'text-sm text-white/80 italic' : 'text-sm text-blue-800 italic';

  return (
    <p className={`${textClass} ${className}`.trim()} aria-live="polite">
      {loading ? 'Join monthly donors already keeping patients alive.' : formatMonthlyWarriorSocialProof(count)}
    </p>
  );
}
